'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope){

    $('body').append('<div class="scroll-line"></div>');

    var scrollLine = $('.scroll-line');

    //capture scroll any percentage
    $(window).scroll(function() {
        var wintop = $(window).scrollTop(),
            docheight = $(document).height(),
            winheight = $(window).height();

        var scrolled = (wintop / (docheight - winheight)) * 100;
        scrollLine.css('width', (scrolled.toFixed() + '%'));
    });
}
